import type {z} from "zod";

import {UpdateServiceFunctionBody} from "@project/sdk/engineering/zod";

export const updateServiceFunctionFormSchema = UpdateServiceFunctionBody;
export type UpdateServiceFunctionFormPayload = z.output<typeof updateServiceFunctionFormSchema>;

export const draftUpdateServiceFunctionFormSchema = updateServiceFunctionFormSchema.partial();
export type DraftUpdateServiceFunctionFormPayload = z.output<
  typeof draftUpdateServiceFunctionFormSchema
>;
